import Services from '../Services/Services/Services';
import toast from 'react-hot-toast'
const AddService = () => {
    const handleAdd = (event) => {
        event.preventDefault();
        const form = event.target;
        const title = form.title.value;
        const image_url = form.image_url.value;
        const price = form.price.value;
        const rating = form.rating.value;
        const details = form.details.value;
        const service = {
            title, image_url, price, rating, details
        }
        fetch('https://assignment-11-server-sooty.vercel.app/services',{
            method : 'POST',
            headers : {
                'content-type' : 'application/json'
            },
            body : JSON.stringify(service)
        })
        .then(res => res.json())
        .then(data => {
            if(data.acknowledged){
                toast.success('Successfully toasted!')
                form.reset()
            }
        })
        .catch(error => console.error(error))
    }
    return (
        <div className='my-5'>
            <form onSubmit={handleAdd} className='w-80 mx-auto'>
                <div className="form-control">
                    <label className="label">
                        <span className="label-text">Product Title</span>
                    </label>
                    <input type="text" name='title' placeholder="Product Name" className="input input-bordered" />

                    <label className="label">
                        <span className="label-text">Image Url</span>
                    </label>
                    <input type="text" name='image_url' placeholder="image_url" className="input input-bordered" />

                    <label className="label">
                        <span className="label-text">Price</span>
                    </label>
                    <input type="number" name='price' placeholder="price" className="input input-bordered" />

                    <label className="label">
                        <span className="label-text">Rating</span>
                    </label>
                    <input type="number" name='rating' placeholder="Rating" className="input input-bordered" />

                    <label className="label">
                        <span className="label-text">Details</span>
                    </label>
                    <textarea name='details' className="textarea textarea-bordered" placeholder="Details"></textarea>
                </div>
                <div className='my-3 text-center'>
                    <button type='submit' className="btn min-h-8 h-8 btn-primary">Add a Service</button>
                </div>
            </form>
        </div>
    );
};

export default AddService;